<p-dialog [(visible)]="isVisible" (onHide)="streamSubscription?.unsubscribe(); streamSubscription = null" appendTo="body" [focusOnShow]="false" [draggable]="false" [modal]="true"
  [resizable]="false" [closable]="true"
  styleClass="z-[1000] py-0 rounded-2xl w-full h-full max-h-[90vh] max-w-7xl border-0 shadow-2xl shadow-indigo-500/20 focus:outline-none backdrop-blur-sm bg-white/95 overflow-auto">
  <ng-template #header>
    <div class="flex flex-col justify-center items-center w-full px-3 pt-3">
      <span class="font-bold text-2xl text-blue-700">{{ state ? state.name : 'Oops...' }}</span>
    </div>
  </ng-template>
  <div class="px-6 pb-6 space-y-6 overflow-auto scroll-smooth">
    @if(!state.component) {
    <div class="flex items-center justify-center p-8">
      <div class="text-center">
        <div class="w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
          <svg class="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <p class="text-lg font-medium text-gray-900 mb-2">Something went wrong</p>
        <p class="text-gray-500">Unable to load the component</p>
      </div>
    </div>
    }
    @else {
    <div class="space-y-4 border-t border-gray-200 pt-3">
      <div class="flex justify-between">
        <div class="w-1/2">
          <div class="flex items-center space-x-2 mb-3">
            <div class="w-2 h-2 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full"></div>
            <h3 class="text-xl font-semibold text-gray-900">Pdf viewer</h3>
          </div>
          <div
            class="relative h-100 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl overflow-hidden text-sm font-mono text-gray-800 border border-gray-200 shadow-inner leading-relaxed">
            <app-pdf-viewer />
          </div>
        </div>
        <div class="w-1/2 pl-6">
          <div class="flex items-center space-x-2 mb-3">
            <div class="w-2 h-2 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full"></div>
            <h3 class="text-xl font-semibold text-gray-900">Extracted Data</h3>
          </div>
          <div
            class="relative h-100 bg-gradient-to-br from-gray-50 to-gray-100 p-5 rounded-xl overflow-auto text-sm border border-gray-200 shadow-inner leading-relaxed">
            <ng-container [ngComponentOutlet]="state.component"></ng-container>
          </div>

        </div>
      </div>
      <div>
        <div class="flex items-center space-x-2 mb-3">
          <div class="w-2 h-2 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full animate-pulse"></div>
          <h3 class="text-xl font-semibold text-gray-900">Agent Thought</h3>
          @if(isRunningState) {
          <div class="flex justify-center ml-2 space-x-1">
            <div class="w-2 h-4 bg-blue-500 rounded-full animate-bounce"
              style="animation-delay: 0s; --tw-animate-bounce: 0 0, 0 -0.5rem, 0 0"></div>
            <div class="w-2 h-4 bg-blue-500 rounded-full animate-bounce"
              style="animation-delay: 0.1s; --tw-animate-bounce: 0 0, 0 -0.5rem, 0 0"></div>
            <div class="w-2 h-4 bg-blue-500 rounded-full animate-bounce"
              style="animation-delay: 0.2s; --tw-animate-bounce: 0 0, 0 -0.5rem, 0 0"></div>
          </div>
          }
        </div>
        <div #messageContainer id="messageContainer"
          class="relative h-40 bg-white/80 backdrop-blur-sm rounded-xl p-5 border border-blue-200/50 shadow-sm overflow-auto">
          <div class="text-gray-700 leading-relaxed">
            @if(stateUpdatesStream()) {
            <div class="markdown-content prose prose-sm max-w-none">
              <markdown [data]="stateUpdatesStream()"></markdown>
            </div>
            }
            @else{
            @if(data && data.aiThought) {
            <div class="markdown-content prose prose-sm max-w-none">
              <markdown [data]="data.aiThought"></markdown>
            </div>
            }
            }
          </div>
        </div>
      </div>
      @if(!isRunningState) {
      <div>
        <div class="flex items-center space-x-2 mb-3">
          <div class="w-2 h-2 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full"></div>
          <h3 class="text-xl font-semibold text-gray-900">Re-Run Comment</h3>
        </div>
        <div>
          <textarea placeholder="Write your comment here..." [(ngModel)]="reRunMessage"
            class="w-full px-3 py-2 text-sm sm:text-base bg-white border border-slate-200 rounded-md focus:outline-none shadow-sm  text-slate-800" rows="2"></textarea>
        </div>
      </div>
      <div class="flex justify-center">
        <button (click)="reRunState()"
          class="w-full sm:w-auto sm:ml-4 bg-[#1594FD] hover:bg-[#0F7ED8] text-white font-medium py-4 sm:py-2 px-6 sm:px-4 rounded-lg transform hover:-translate-y-0.5 transition-all duration-200 cursor-pointer disabled:cursor-not-allowed text-xs sm:text-sm">
          Re-Run
        </button>
      </div>
      } @else {
        <div class="flex justify-center">
          <button (click)="handleStop()"
            class="w-full flex items-center justify-center gap-2 sm:w-auto sm:ml-4 bg-red-500 hover:bg-red-600 text-white font-medium py-4 sm:py-2 px-6 sm:px-4 rounded-lg transform hover:-translate-y-0.5 transition-all duration-200 cursor-pointer disabled:cursor-not-allowed text-xs sm:text-sm">
            @if(spinning) {
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            }
            Stop
          </button>
        </div>
      }
    </div>
    }
    <!-- Add your content for viewing and validating extraction mapping here -->
  </div>

</p-dialog>